/* @flow */

import type { Action, RootState } from '../types'

export const STATE_KEY: string = 'inflightRequests'

export const BEGIN_FETCHING: string = 'opinary/BEGIN_FETCHING'
export const END_FETCHING: string = 'opinary/END_FETCHING'

export function beginFetching(): Action {
  return {
    type: BEGIN_FETCHING,
  }
}

export function endFetching(): Action {
  return {
    type: END_FETCHING,
  }
}

export function selectInflightRequestCount(rootState: RootState): number {
  return rootState[STATE_KEY]
}

export function selectHasInflightRequests(rootState: RootState): boolean {
  return rootState[STATE_KEY] > 0
}

export default function reducer(state: number = 0, action: Action): number {
  switch (action.type) {
    case BEGIN_FETCHING:
      return state + 1
    case END_FETCHING:
      if (state < 1) {
        throw new Error(
          'endFetching() was called more times than beginFetching() and must not be'
        )
      }
      return state - 1
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/stores/inflightRequests.js